import { useTranslation } from "react-i18next";
import { useContext } from "react";
import { WAIVED_INTEREST, INTRO_RATE_LOAN } from "../../const/conditions";
import PRODUCT_TYPE from "../../const/productType";
import { useAccountSummary, useAutopayStatus, } from "../../helpers/syfApiQueries";
import getRevolvingCreditDataSections from "./getRevolvingCreditDataSections";
import getPayLaterMonthlyDataSections from "./getPayLaterMonthlyDataSections/getPayLaterMonthlyDataSections";
import getPayLaterPN4DataSections from "./getPayLaterPN4DataSections";
import getSecuredInstallmentDataSections from "./getSecuredInstallmentDataSections";
import DetailsModalContext from "../../DetailsModalContext";
import getWaivedInterestDataSections from "./getWaivedInterestDataSections";
import getSetpayDataSections from "./getSetpayDataSections";
import getIntroRateLoanDataSections from "./getIntroRateLoanDataSections";
import MainContext from "../../ui/Context";
var useDataSections = function () {
    var _a;
    var t = useTranslation().t;
    var _b = useContext(MainContext), helpNumber = _b.helpNumber, featureFlags = _b.featureFlags;
    var accountSummaryData = useAccountSummary().data;
    var autopayStatusData = useAutopayStatus().data;
    var productType = (_a = accountSummaryData === null || accountSummaryData === void 0 ? void 0 : accountSummaryData.product) === null || _a === void 0 ? void 0 : _a.type;
    var setIsWaivedInterestTooltip = useContext(DetailsModalContext).setIsWaivedInterestTooltip;
    if (!accountSummaryData || !autopayStatusData) {
        return {
            dataSections: [],
        };
    }
    switch (productType) {
        case PRODUCT_TYPE.DUAL_CARD:
        case PRODUCT_TYPE.LIMITED_USE_DUAL_CARD:
        case PRODUCT_TYPE.PRIVATE_LABEL:
            return getRevolvingCreditDataSections(accountSummaryData, autopayStatusData, t);
        case PRODUCT_TYPE.INSTALLMENT_LOAN_MONTHLY:
            if (featureFlags.isIRLEnabled &&
                accountSummaryData.enrollments.includes(INTRO_RATE_LOAN)) {
                return getIntroRateLoanDataSections(accountSummaryData, autopayStatusData, t);
            }
            if (accountSummaryData.enrollments.includes(WAIVED_INTEREST)) {
                return getWaivedInterestDataSections(accountSummaryData, autopayStatusData, t, setIsWaivedInterestTooltip);
            }
            return getPayLaterMonthlyDataSections(accountSummaryData, autopayStatusData, t);
        case PRODUCT_TYPE.INSTALLMENT_LOAN_PAY_IN_FOUR:
            return getPayLaterPN4DataSections(accountSummaryData, autopayStatusData, t);
        case PRODUCT_TYPE.INSTALLMENT_LOAN_SECURED:
            return getSecuredInstallmentDataSections(accountSummaryData, autopayStatusData, helpNumber, t);
        case PRODUCT_TYPE.INSTALLMENT_LOAN:
            return getSetpayDataSections(accountSummaryData, autopayStatusData, t);
        default:
            throw new Error("Unrecognized product type \"".concat(productType, "\""));
    }
};
export default useDataSections;
//# sourceMappingURL=useDataSections.js.map